var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47221 0C5.21634 0 6.6342 1.46407 6.6342 3.26731C6.6342 5.06947 5.21634 6.53 3.47221 6.53C1.7233 6.53 0.309326 5.06947 0.309326 3.26731C0.309326 1.46407 1.7233 0 3.47221 0ZM0.742672 27.125H6.2007V9.00648H0.742672V27.125Z",
    fill: "#FFDD00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2058_7396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 19,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81421 8.79382H27.5746V27.0093H9.81421V8.79382Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2058_7396)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81421 9.23272H15.2773V11.6647H15.3557C16.1154 10.2655 17.973 8.79382 20.7429 8.79382C26.51 8.79382 27.5746 12.4742 27.5746 17.2595V27.0093H21.8819V18.3647C21.8819 16.3034 21.8452 13.6503 18.9215 13.6503C15.9594 13.6503 15.5067 15.8983 15.5067 18.2168V27.0093H9.81421V9.23272Z",
    fill: "#FFDD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedYellow);
export default __webpack_public_path__ + "static/media/linked-yellow.c469e88651a1ed56a3328dd4c84eb8d8.svg";
export { ForwardRef as ReactComponent };